import React from 'react';
import Scroll from 'react-scroll';
import FormControl from 'react-bootstrap/FormControl';
import Select from 'react-select';

import Display from '../../../util/Display';
import CountryCodes from '../../../util/CountryCode';

class FieldMultiPhone extends React.Component {

  static Phone = 'phone';
  static Code = 'code';

  delete = index => {
    const key = this.props.id;
    this.props.onValueChange(key, [ ...this.props.value ].filter((_, i) => i !== index));
  }

  add = () => {
    const key = this.props.id;
    const values = [ ...this.props.value, { code: CountryCodes.find(item => item.value === '+91'), phone: '' } ];
    this.props.onValueChange(key, values);
  }

  handleChange = (index, field, value) => {
    const key = this.props.id;
    const values = [ ...this.props.value ];
    if(field === FieldMultiPhone.Phone) {
      values[index][FieldMultiPhone.Phone] = value;
    } else if(field === FieldMultiPhone.Code) {
      values[index][FieldMultiPhone.Code] = value;
    }
    this.props.onValueChange(key, values);
  }

  render() {
    const key = this.props.id;
    const field = this.props.field;
    const visible = this.props.visible;
    const editable = this.props.editable;
    const mandatory = this.props.mandatory;
    const values = this.props.value;
    const error = this.props.error;
    const errorMessage = this.props.errorMessage;

    if(!visible || !editable) return null;
  
    return (
      <div className="col contactinfodiv">
        <Scroll.Element name={key} />
        <label> {field.label_name} { mandatory ? <span className="required-field"/> : null} </label>
        { error ? <>&nbsp; : &nbsp; <label className="error-w">{errorMessage}</label></> : null }
        {
          values.map((value, i) =>
            <div key={`${key}_${i + 1}`} className="form-group">
              <div className="phone-code">  
                <Select
                  value={value.code}
                  options={CountryCodes}
                  isSearchable={true}
                  onChange={seletced => this.handleChange(i, FieldMultiPhone.Code, seletced)} />

                <FormControl
                  type="number"
                  value={value.phone}
                  placeholder={field.label_name}
                  onChange={evt => this.handleChange(i, FieldMultiPhone.Phone, evt.target.value.replace(/[^0-9+-]/g, ''))}
                  className={`mr-sm-2 ${error ? 'error-w' : ''}`}
                  readOnly={!editable} />
              </div>
              { Display.MultiAction(i, this.add, this.delete) }
            </div>
          )
        }
      </div>
    );
  }
}
export default FieldMultiPhone;